<template>
  <v-container class="scrollable-container">
    <v-row justify="center">
      <v-col cols="8" sm="6" md="5" lg="4" xl="3">
        <v-row justify="center">
          <v-img
            contain
            class="light-round-image-border"
            :style="$vuetify.breakpoint.xs ? 'margin-top: 55px;' : 'margin-top: 55px;max-width: 371px;'"
            :src="errorMessage.length ? errorPageImage : imageUrl"
          ></v-img>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="center">
      <h2 class="pageTitle mt-5">{{errorMessage.length ? errorPageTitle : title }}</h2>
    </v-row>
    <v-row justify="center">
      <p v-if="customErrorText.length" class="pageText">{{customErrorText}}</p>
      <p v-else-if="texts.length > 1" class="pageText">
        {{errorMessage.length ? errorPageText : texts[0]}}
        <br v-if="!errorMessage.length" />
        {{!errorMessage.length ? texts[1] : ''}}
      </p>
      <p v-else class="pageText">{{errorMessage.length ? errorPageText : text }}</p>
    </v-row>
    <v-row v-if="!noButtons" justify="center" style="padding-bottom:60px;">
      <v-col cols="12" :sm="button2Text.length ? 6 : 12">
        <v-row :justify-sm="button2Text.length ? 'end' : 'center'" justify="center">
          <v-btn
            v-if="button2Text.length"
            :class="{'mr-2':$vuetify.breakpoint.smAndUp}"
            class="pageButton"
            width="200"
            height="52"
            color="primary"
            @click="$emit('button2-clicked')"
          >{{button2Text}}</v-btn>
        </v-row>
      </v-col>
      <v-col cols="12" :sm="button2Text.length ? 6 : 12">
        <v-row :justify-sm="button2Text.length ? 'start' : 'center'" justify="center">
          <v-btn
            :class="{'ml-2':$vuetify.breakpoint.smAndUp && button2Text.length}"
            class="pageButton"
            width="200"
            height="52"
            color="primary"
            @click="$emit('button-clicked')"
          >{{buttonText}}</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ERRORS } from "../../../utilities/enums";
export default {
  data: () => ({
    allErrors: ERRORS,
  }),
  computed: {
    texts() {
      return this.text.split("|");
    },
    errorPageImage() {
      if (this.errorIs(this.allErrors.ER404))
        return "/img/dynamic-src-images/errors/404-error.svg";
      else return "/img/dynamic-src-images/errors/oops-error.svg";
    },
    errorPageTitle() {
      if (this.errorIs(this.allErrors.ER404))
        return "Sorry.. the thing you are looking for is not found";
      else if (this.errorIs(this.allErrors.ER500))
        return "Sorry.. there was an error on the server";
      else if (this.errorIs(this.allErrors.NETWORKERROR))
        return "Connection refused";
      else return "Sorry.. something went wrong";
    },
    errorPageText() {
      return "Click on Reload button below to reload this page";
    },
  },
  methods: {
    errorIs(hasThis) {
      return this.errorMessage.search(hasThis) != -1;
    },
  },
  props: {
    imageUrl: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    button2Text: {
      type: String,
      default: "",
    },
    noButtons: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    customErrorText: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.theme--light .light-round-image-border {
  border: 1px solid rgb(0, 0, 0, 0.15);
  border-radius: 200px;
}
.pageTitle {
  margin-top: 38px;
  color: #47bd96;
  font-family: Dosis;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 3.67px;
  text-transform: uppercase;
  text-align: center;
}
.pageText {
  margin-top: 15px;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 1px;
  line-height: 28px;
  text-align: center;
  max-width: 460px;
}
.pageButton {
  width: 183px;
  height: 22px;
  color: #ffffff;
  font-family: Dosis;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase !important;
}
</style>